module.exports = __webpack_public_path__ + "dingbeauty/admin/img/fbUrl.03bae35a.jpg";